import axios from 'axios';
import _ from 'lodash';
import * as urls from './urlTypes';
import * as types from './actionTypes';
import { findRelatedDataOnScreen, getFilterConfig, setSalesCatalystDataOnSave,
  getBrandAndMediaFiltersFromPreferences } from '../util/SalesCatalystUtils';
import { getStudyFromStudies } from '../util/CommonUtils';
import {
  toastSuccess,
  toastWarning,
} from '../util/toastUtils';
import {
  PREFERENCE_SALES_CATALYST,
  SALES_CATALYST_REDUCERS_BASE,
  SALES_CATALYST_API_SUBENTITIES,
  SALES_CATALYST_API_AUDIENCE,
  SC_PACKAGE_CHARTS,
  SC_COMPETITORS_ACTIVITIES,
  SC_COMPETITORS_COMPARISON,
  SC_SUB_ENTITY_REPORT,
  PREFERENCE_STUDY,
  STRENGTHS_FILTER_CONFIG,
  WEAKNESS_FILTER_CONFIG,
} from '../constants';

export const addSalesCatalystDataPoints = (headerInfo, mainCategory, subCategory) => ({
  type: types.ADD_AUDIENCE_DATA_POINTS,
  payload: headerInfo,
  mainCategory,
  subCategory,
});

export const setSalesBase = baseInfo => {
  return dispatch =>
  new Promise(resolve => {
    dispatch({
      type: types.SAVE_SALES_CATALYST_BASE_INFO,
      payload: baseInfo,
    });
    resolve(true);
  });
};

export const handleClearSalesBaseClick = () => {
  return dispatch =>
  new Promise(resolve => {
    dispatch({
      type: types.REMOVE_SALES_CATALYST_BASE_INFO,
    });
    resolve(true);
  });
};

export const resetSalesCatalyst = () => {
  return dispatch =>
  new Promise(resolve => {
    dispatch({
      type: types.RESET_SALES_CATALYST,
    });
    resolve(true);
  });
};

export const resetSalesBrandSummary = () => ({
  type: types.RESET_SALES_BRAND_SUMMARY,
});

export const resetSalesPitchSummary = () => ({
  type: types.RESET_SALES_PITCH_SUMMARY,
});

export const deleteInputTableItem = (field, index) => ({
  type: types.DELETE_INPUT_TABLE_ITEM,
  payload: {
    index,
    field,
  },
});

export const saveDataToDefinitionFolder = (
  token,
  uid,
  accountId,
  productNo,
  data,
  callbackFn,
  callbackFnForDefinition,
  indexToUpdate,
  category,
  callbackFnForceLabelUpdate,
) => {
  const url = `${
    urls.ROOT_URL
  }/si360/save-persona/${uid}/${accountId}/${productNo}`;
  return (dispatch, getState) => {
    const updateDataOnScreen = findRelatedDataOnScreen(category.subCategory, getState());
    if (updateDataOnScreen.dataOnScreenStatus) {
      dispatch({
        type: types.UPDATE_DATA_ON_SCREEN,
        payload: {
          dataOnScreen: updateDataOnScreen.dataOnScreenReset,
          graphData: updateDataOnScreen.resetGraphData,
        },
      });
    }
    return axios({
      url,
      method: 'post',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      data,
      validateStatus: status => status >= 200 && status < 501,
    })
      .then(response => {
        if (response.status === 200) {
          let label = null;
          let labelExpression = null;
          let expressionId = null;
          response.data.data.expressions.forEach(expression => {
            if (data.expressions[0].title === expression.title) {
              label = expression.title;
              expressionId = expression.id;
              labelExpression = expression.expression;
            }
          });
          if (category !== undefined && category.mainCategory !== undefined) {
            if (category.mainCategory === SALES_CATALYST_REDUCERS_BASE) {
              const baseInfo = {
                label,
                expression: labelExpression,
              };
              dispatch({
                type: types.SAVE_SALES_CATALYST_BASE_INFO,
                payload: baseInfo,
              });
            } else {
              Promise.resolve(dispatch({
                type: types.UPDATE_SALES_CATALYST_SELECTION,
                data: {
                  label,
                  labelExpression,
                  expressionId,
                  defId: response.data.data.defId,
                  indexToUpdate,
                },
                category,
              })).then(() => {
                if (updateDataOnScreen.dataOnScreenStatus) {
                  dispatch({
                    type: types.UPDATE_DATA_ON_SCREEN,
                    payload: {
                      dataOnScreen: updateDataOnScreen.dataOnScreenPrev,
                      graphData: updateDataOnScreen.resetGraphData,
                    },
                  });
                }
              });
            }
          } else if (callbackFnForceLabelUpdate !== undefined) {
            callbackFnForceLabelUpdate({
              data: {
                label,
                labelExpression,
                expressionId,
                defId: response.data.data.defId,
                indexToUpdate,
              },
            });
          }
          callbackFnForDefinition();
          return callbackFn(true);
        }
        if (response.status === 400) {
          toastWarning(response.data.message);
          if (updateDataOnScreen.dataOnScreenStatus) {
            dispatch({
              type: types.UPDATE_DATA_ON_SCREEN,
              payload: {
                dataOnScreen: updateDataOnScreen.dataOnScreenPrev,
                graphData: updateDataOnScreen.prevGraphData,
              },
            });
          }
          return callbackFn(false);
        }
        return callbackFn(false);
      })
      .catch(response => {
        if (updateDataOnScreen.dataOnScreenStatus) {
          dispatch({
            type: types.UPDATE_DATA_ON_SCREEN,
            payload: {
              dataOnScreen: updateDataOnScreen.dataOnScreenPrev,
              graphData: updateDataOnScreen.prevGraphData,
            },
          });
        }
        console.warn(response);
        return callbackFn(false);
      });
  };
};

export const saveSCTemplate = ({
  token,
  uid,
  accountId,
  productNo,
  data,
  type,
}) => {
  const url = `${urls.ROOT_URL}/sc/save-${type}-template/${uid}/${accountId}/${productNo}`;
  return () => {
    return axios({
      url,
      method: 'post',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      data,
      validateStatus: status => status >= 200 && status < 501,
    }).then(response => {
      if (response.status === 200) {
        toastSuccess(`${type === SALES_CATALYST_API_SUBENTITIES ? 'List' : 'Template'} has been saved successfully`);
        return response.data.data;
      }
      toastWarning(response.data.message);
      return false;
    }).catch(response => {
      console.warn(response);
      toastWarning(response.data.message);
      return false;
    });
  };
};
export const scActionGetMethod = ({ token, userId, accountId, productNo, type, searchText }) => {
  let url = '';
  if (type === SALES_CATALYST_API_AUDIENCE) {
    url = `${urls.ROOT_URL}/sc/search-audience-template/${userId}/${accountId}?searchText=${searchText !== undefined ? searchText : ''}`;
  } else if (type === SALES_CATALYST_API_SUBENTITIES) {
    url = `${urls.ROOT_URL}/sc/list-subentities-template/${userId}/${accountId}/${productNo}`;
  }
  return () => axios({
    url,
    method: 'get',
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json;charset=UTF-8',
    },
    responseType: 'json',
    withCredentials: true,
  })
    .then(response => {
      return response.data.data;
    })
    .catch(response => {
      console.warn(response);
      return false;
    });
};

export const clearSearchResult = () => ({
  // type: types.CLEAR_SALES_BRANDS_SECTION_SEARCH_RESULT,
});


export const clearBoxSearch = () => ({
  type: types.CLEAR_SALES_BRANDS_SECTION_SEARCH_RESULT,
});


export function getSampleWeighted({
  token,
  uid,
  accountId,
  productNo,
  weightType,
  divisor,
  expressionList,
}) {
  const url = `${urls.ROOT_URL}/crosstab/samplewgtd`;
  return dispatch => axios({
    url,
    method: 'post',
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json;charset=UTF-8',
    },
    withCredentials: true,
    responseType: 'json',
    data: {
      uid,
      accountId,
      productNo,
      divisor,
      weightType,
      expressionList,
    },
  })
    .then(response => { return response.data.data; })
    .catch(error => {
      console.log(`some error occured for this${error}`);
    });
}

export const updateSelectionsData = (dataSelection, salesCatalystBase) => {
  return dispatch =>
  new Promise(resolve => {
    dispatch({
      type: types.UPDATE_DATA_ON_STUDY_CHANGE,
      payload: {
        dataSelection,
        salesCatalystBase: salesCatalystBase || undefined,
      },
    });
    resolve(true);
  });
};

export const updateDataOnScreen = dataOnScreen => {
  return dispatch =>
  new Promise(resolve => {
    dispatch({
      type: types.UPDATE_SC_DATA_ON_SCREEN,
      payload: {
        dataOnScreen,
      },
    });
    resolve(true);
  });
};

export function scLoadTemplate({
  token,
  uid,
  accountId,
  type,
  data,
}) {
  let url;
  if (type === SALES_CATALYST_API_SUBENTITIES && data.templateId === 0) {
    url = `${urls.ROOT_URL}/sc/load-default-subentities/${uid}/${accountId}`;
  } else {
    url = `${urls.ROOT_URL}/sc/load-${type}-template/${uid}/${accountId}`;
  }
  return () => axios({
    url,
    method: 'post',
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json;charset=UTF-8',
    },
    withCredentials: true,
    responseType: 'json',
    data,
  })
    .then(response => {
      return response.data.data;
    })
    .catch(error => {
      console.warn(error);
    });
}

export const updateSelectedTemplateData = (data, section) => {
  return ({
    type: types.UPDATE_SELECTED_TEMPLATES_DATA,
    payload: {
      section,
      data,
    },
  });
};

export const deleteSalesCatalystSelection = (mainCategory, subCategory, section, index) => {
  return ({
    type: types.DELETE_SALES_CATALYST_SELECTION,
    payload: {
      mainCategory,
      subCategory,
      section,
      index,
    },
  });
};
export const runSalesCatalyst = (runTargetMarket, runCompetition, runMediaPackage) => {
  return dispatch =>
  new Promise(resolve => {
    dispatch({
      type: types.RUN_SALES_CATALYST,
      payload: {
        targetMarket: runTargetMarket,
        competition: runCompetition,
        mediaPackage: runMediaPackage,
      },
    });
    resolve(true);
  });
};

export const resetSalesCatalystScreen = (section, options, studyChangeBaseValid,
  noAddInfoReset) => {
  return (dispatch, getState) =>
  new Promise(resolve => {
    dispatch({
      type: types.RESET_SALES_CATALYST_SCREEN,
      payload: {
        section,
        options,
        studyChangeBaseValid,
        noAddInfoReset,
        filters: getBrandAndMediaFiltersFromPreferences(getState().preferences),
      },
    });
    resolve(true);
  });
};

export function getOverlapWeighted(response) {
  return ({
    type: types.GET_OVERLAP_SAMPLE_WEIGHTED_DATA,
    data: response.data.data[0],
  });
}

export function getDemoMarketDataList(
  token,
  userId,
  accountId,
  productNo,
  personaLabels,
  personaExpressions,
  reportName,
  top,

) {
  const url = `${urls.ROOT_URL}/si360/dataRequest/${userId}/${accountId}`;
  return (dispatch, getState) => {
    const base = getState().salesCatalyst.salesCatalystBase;

    const filterConfig = getFilterConfig(getState, reportName);

    let data = {};

    if (base !== undefined) {
      data = {
        baseExpression: base.expression,
        baseLabel: base.label,
        reportName,
        personaLabels,
        personaExpressions,
        filterConfig,
        productNo,
        top,
      };
    } else {
      data = {
        reportName,
        personaLabels,
        personaExpressions,
        filterConfig,
        productNo,
        top,
      };
    }
    axios({
      url,
      method: 'post',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      data,
    })
    .then(response => {
      dispatch({
        type: types.SHOW_SALES_DEMO_MARKET_DATA,
        payload: response.data,
      });
      return true;
    })
    .catch(response => {
      console.warn(response);
      return false;
    });
  };
}

export function attitudeMarketDataList(
  token,
  userId,
  accountId,
  productNo,
  personaLabels,
  personaExpressions,
  reportName,
  top,

) {
  const url = `${urls.ROOT_URL}/si360/dataRequest/${userId}/${accountId}`;
  return (dispatch, getState) => {
    const base = getState().salesCatalyst.salesCatalystBase;

    const filterConfig = getFilterConfig(getState, reportName);

    let data = {};
    if (base !== undefined) {
      data = {
        baseExpression: base.expression,
        baseLabel: base.label,
        reportName,
        personaLabels,
        personaExpressions,
        filterConfig,
        productNo,
        top,
      };
    } else {
      data = {
        reportName,
        personaLabels,
        personaExpressions,
        filterConfig,
        productNo,
        top,
      };
    }
    axios({
      url,
      method: 'post',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      data,
    })
    .then(response => {
      dispatch({
        type: types.SHOW_SALES_ATTITUDE_MARKET_DATA,
        payload: response.data.data,
      });
      return true;
    })
    .catch(response => {
      console.warn(response);
      return false;
    });
  };
}

export function getSalesHeaderInfo(
  token,
  uid,
  accountId,
  headerInfo,
  reportName,
  productNo,
  textInputFlag,
) {
  return (dispatch, getState) => {
    const url = `${urls.ROOT_URL}/si360/dataRequest/${uid}/${accountId}`;
    const base = getState().salesCatalyst.salesCatalystBase;
    let data = {};
    if (base !== undefined) {
      data = {
        baseExpression: base.expression,
        baseLabel: base.label,
        reportName,
        personaLabels: headerInfo.label,
        personaExpressions: headerInfo.expression,
        productNo,
        filterConfig: {
          sample: '>0',
          pct: '>0',
          index: '>0',
        },
      };
    } else {
      data = {
        reportName,
        personaLabels: headerInfo.label,
        personaExpressions: headerInfo.expression,
        productNo,
        filterConfig: {
          sample: '>0',
          pct: '>0',
          index: '>0',
        },
      };
    }

    return axios({
      url,
      method: 'post',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      data,
      validateStatus: status => status >= 200 && status < 501,
    })
      .then(response => {
        if (response.status === 200) {
          if (textInputFlag) {
            return response.data;
          } else {
            dispatch({
              type: types.GET_OVERLAP_SAMPLE_WEIGHTED_DATA,
              data: response.data.data[0].headers[1],
            });
          }
        }
      })
      .catch(response => console.warn(response));
  };
}

export function getSampleWeightedReachInfo({
  token,
  uid,
  accountId,
  expressionList,
  reportName,
  productNo,
  divisor,
  weightType,
}) {
  return (dispatch, getState) => {
    const url = `${urls.ROOT_URL}/sc/data-request/${uid}/${accountId}`;
    const base = getState().salesCatalyst.salesCatalystBase;
    let data = {};
    if (base !== undefined) {
      data = {
        baseExpression: base.expression,
        baseLabel: base.label,
        reportName,
        expressionList,
        productNo,
        divisor,
        weightType,
      };
    } else {
      data = {
        reportName,
        expressionList,
        productNo,
        divisor,
        weightType,
      };
    }

    data.filterConfig = {
      sample: '>0',
      pct: '>0',
      index: '>0',
    };

    return axios({
      url,
      method: 'post',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      data,
      validateStatus: status => status >= 200 && status < 501,
    })
      .then(response => {
        return response.data;
      })
      .catch(response => console.warn(response));
  };
}


export const resetOverlapWeighted = () => ({
  type: types.RESET_OVERLAP_SAMPLE_WEIGHTED_DATA,
});


export const clearAttitudeDemoSectionData = () => ({
  type: types.RESET_ATTITUDE_DEMO_SECTION_DATA,
});

export const setDataOnScreenVal = (section, status) => ({
  type: types.SET_DATA_ON_SCREEN_VAL,
  payload: {
    section,
    status,
  },
});

export const resetMediaPackagecategory = () => ({
  type: types.RESET_MEDIA_PACKAGE_CATEGORY,
});
export const setMediaPackageInputFlag = flag => ({
  type: types.SET_MEDIA_PACKAGE_INPUT_FLAG,
  payload: flag,
});

export function fetchBrandCategory({
  token,
  uid,
  accountId,
  productNo,
  weightType,
  divisor,
  brandExpression,
}) {
  const url = `${urls.ROOT_URL}/sc/get-brand-category/${uid}/${accountId}`;
  return (dispatch, getState) => {
    const base = getState().salesCatalyst.salesCatalystBase;
    let data = {};
    if (base !== undefined) {
      data = {
        baseExpression: base.expression,
        baseLabel: base.label,
        productNo,
        divisor,
        weightType,
        brandExpression,
      };
    } else {
      data = {
        productNo,
        divisor,
        weightType,
        brandExpression,
      };
    }
    return axios({
      url,
      method: 'post',
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      data,
    })
    .then(response => {
      dispatch({
        type: types.FETCH_BRAND_CATEGORY,
        data: response.data.data,
      });
    })
    .catch(error => {
      console.log(`some error occured for this${error}`);
    });
  };
}

const findReportType = (chartType, reportName) => {
  if (chartType === SC_SUB_ENTITY_REPORT) {
    return _.camelCase(SC_SUB_ENTITY_REPORT);
  }
  return _.camelCase(reportName);
};

export function getBarChartReport({
  token,
  uid,
  accountId,
  productNo,
  reportName,
  targetLabel,
  targetExpression,
  entityLabel,
  entityExpression,
  brandLabel = '',
  brandExpression = '',
  vpctFilter = 10,
  top = 15,
  minSampleSize = 0,
  chartType,
  competitors,
  passTargetVal,
  sortBy = 'index',
  subCategories,
  activitiesTemplate,
  objIndex,
}) {
  const url = `${urls.ROOT_URL}/sc/data-request/${uid}/${accountId}`;
  return (dispatch, getState) => {
    const base = getState().salesCatalyst.salesCatalystBase;
    const filterConfig = getFilterConfig(getState, reportName);
    const strengthFilterConfig = getFilterConfig(getState, reportName, STRENGTHS_FILTER_CONFIG);
    const weaknessFilterConfig = getFilterConfig(getState, reportName, WEAKNESS_FILTER_CONFIG);

    const subEntitiesTemplate = getState().salesCatalyst.scConfiguration.package.appliedList;
    const subEntitiesPackageTemplate = getState().salesCatalyst.scConfiguration.package.selectedList;
    let data = {};
    if (base !== undefined) {
      data = {
        baseExpression: base.expression,
        baseLabel: base.label,
        productNo,
        reportName,
        targetLabel,
        targetExpression,
        entityLabel,
        entityExpression,
        brandLabel,
        brandExpression,
        filterConfig,
        top,
        minSampleSize,
        sortBy,
      };
    } else {
      data = {
        productNo,
        reportName,
        targetLabel,
        targetExpression,
        entityLabel,
        entityExpression,
        brandLabel,
        brandExpression,
        filterConfig,
        top,
        minSampleSize,
        sortBy,
      };
    }

    if (chartType === SC_PACKAGE_CHARTS && (!_.isEmpty(subEntitiesPackageTemplate) ||
    !_.isEmpty(subEntitiesTemplate))) {
      const templateData = _.isEmpty(subEntitiesPackageTemplate) ? subEntitiesTemplate :
      subEntitiesPackageTemplate;
      const { templateId, templateName } = templateData;
      data.subEntitiesTemplate = {
        templateId,
        templateName,
      };
    }

    if (reportName === SC_COMPETITORS_ACTIVITIES) {
      if (base !== undefined && !passTargetVal) {
        data.targetLabel = null;
        data.targetExpression = null;
      }
    }

    if (reportName === SC_COMPETITORS_COMPARISON) {
      data.filterConfig = undefined;
      data.strengthFilterConfig = strengthFilterConfig;
      data.weaknessFilterConfig = weaknessFilterConfig;
    }

    if (competitors !== undefined) {
      data.competitors = competitors;
    }

    if (subCategories !== undefined) {
      data.subCategories = subCategories;
    }

    if (activitiesTemplate !== undefined) {
      data.activitiesTemplate = activitiesTemplate;
    }
    if (reportName === SC_COMPETITORS_COMPARISON) {
      data.filterConfig = {
        sample: '>0',
        pct: '>0',
        index: '>0',
      };
    }

    axios({
      url,
      method: 'post',
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      data,
    })
  .then(response => {
    dispatch({
      type: types.GET_BAR_CHART_REPORT,
      reportType: findReportType(chartType, reportName),
      data: response.data.data,
      objIndex,
    });
  })
  .catch(error => {
    console.log(`some error occured for this${error}`);
  });
  };
}

export const resetGraphData = field => ({
  type: types.RESET_BAR_CHART_REPORT,
  field,
});

export function searchBrand({
  token,
  uid,
  accountId,
  productNo,
  searchText,
  resolve,
}) {
  const url = `${urls.ROOT_URL}/sc/search-brands/${uid}/${accountId}`;
  return () => axios({
    url,
    method: 'post',
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json;charset=UTF-8',
    },
    withCredentials: true,
    responseType: 'json',
    data: {
      productNo,
      searchText,
    },
  })
  .then(response => {
    resolve(response.data);
  })
  .catch(error => {
    console.log(`some error occured for this${error}`);
  });
}

export const setBrandSampleDetails = brandDetails => ({
  type: types.FETCH_BRAND,
  brandDetails,
});

export const setChartSortInfo = sortInfo => ({
  type: types.SET_CHART_SORT_INFO,
  payload: sortInfo,
});

export function getBrandBarChartReport({
  token,
  uid,
  accountId,
  productNo,
  reportName,
  personaExpressions,
  personaLabels,
  vpctFilter = 10,
  top = 15,
  subCategories = [],
}) {
  const url = `${urls.ROOT_URL}/si360/dataRequest/${uid}/${accountId}`;
  return (dispatch, getState) => {
    const base = getState().salesCatalyst.salesCatalystBase;
    const filterConfig = getFilterConfig(getState, reportName);
    let data = {};
    if (base !== undefined) {
      data = {
        baseExpression: base.expression,
        baseLabel: base.label,
        productNo,
        reportName,
        personaExpressions,
        personaLabels,
        subCategories,
        filterConfig,
        top,
      };
    } else {
      data = {
        productNo,
        reportName,
        personaExpressions,
        personaLabels,
        subCategories,
        filterConfig,
        top,
      };
    }

    return axios({
      url,
      method: 'post',
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      data,
    })
    .then(response => {
      dispatch({
        type: types.GET_BAR_CHART_REPORT,
        reportType: _.camelCase(reportName),
        data: response.data[0],
      });
    })
    .catch(error => {
      console.log(`some error occured for this${error}`);
    });
  };
}

export const setCofigurationPackageData = (value, key) => ({
  type: types.SET_SC_CONFIG_PACKAGE_DATA,
  payload: { value, key },
});

export function getsalesCatalystStudy(token, userId, accountId) {
  // const url = `${urls.ROOT_URL}/si360/product/${userId}/${accountId}`;
  const url = `${urls.ROOT_URL}/users/${userId}/${accountId}/sc-studies`;
  return (dispatch, getState) => axios({
    url,
    method: 'get',
    headers: { Authorization: `Bearer ${token}`, Accept: 'application/json;charset=UTF-8' },
    withCredentials: true,
    responseType: 'json',
  })
    .then(response => {
      if (response.data.data && response.data.data.length === 0) {
        dispatch({
          type: types.NO_SC_STUDIES,
          payload: false,
        });
        return false;
      }
      const preferences = getState().preferences && getState().preferences.userPreferences ?
      getState().preferences.userPreferences : null;
      let selectedStudy = response.data.data[0].sl[0];
      if (!_.isEmpty(preferences) && preferences[PREFERENCE_SALES_CATALYST] !== undefined &&
      preferences[PREFERENCE_SALES_CATALYST][PREFERENCE_STUDY] !== undefined &&
      preferences[PREFERENCE_SALES_CATALYST][PREFERENCE_STUDY] !== -1) {
        selectedStudy = getStudyFromStudies(response.data.data,
          preferences[PREFERENCE_SALES_CATALYST][PREFERENCE_STUDY]);
      }

      new Promise(resolve => {
        dispatch({
          type: types.GET_SC_STUDY,
          payload: response.data.data,
          study: selectedStudy,
        });
        resolve();
      }).then(() => {
        setSalesCatalystDataOnSave(_.cloneDeep(preferences._sc), dispatch, getState);
      });
      return true;
    })
    .catch(response => {
      console.warn(response);
      return false;
    });
}

export const showCofigurationScreen = (value, tabInfo) => ({
  type: types.SHOW_SC_CONFIG_SCREEN,
  payload: { show: value, defaultTab: tabInfo },
});

export const setSalesCatalystStudy = scStudy => {
  return dispatch =>
  new Promise(resolve => {
    dispatch({
      type: types.SET_SC_STUDY,
      payload: scStudy,
    });
    resolve(true);
  });
};

export const setCompetitionData = (value, key, innObj) => ({
  type: types.SET_SC_COMPETITION_DATA,
  payload: { value, key, innObj },
});

export const saveTargetFilterData = (value, key) => ({
  type: types.SET_SC_TARGET_FILTER_DATA,
  payload: { value, key },
});

export function getCategorySearchList({
  token,
  uid,
  accountId,
  reportName,
  searchText,
  productNo,
}) {
  const url = `${urls.ROOT_URL}/si360/category-search/${uid}/${accountId}`;
  return () => axios({
    url,
    method: 'post',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      Accept: 'application/json;charset=UTF-8',
    },
    withCredentials: true,
    responseType: 'json',
    data: {
      reportName,
      productNo,
      searchText,
    },
    validateStatus: status => status >= 200 && status < 501,
  }).then(response => {
    if (response.status === 200) {
      return response.data.data;
    }
    if (response.status === 400) {
      toastWarning(response.data.message);
    }
    return true;
  })
  .catch(response => {
    console.warn(response);
  });
}

export function getActivitiesTemplateList({ token, userId, accountId, productNo, dataReturn }) {
  const url = `${urls.ROOT_URL}/sc/list-activities-templates/${userId}/${accountId}/${productNo}`;
  return dispatch => axios({
    url,
    method: 'get',
    headers: { Authorization: `Bearer ${token}`, Accept: 'application/json;charset=UTF-8' },
    withCredentials: true,
    responseType: 'json',
  })
    .then(response => {
      if (!dataReturn) {
        dispatch({
          type: types.GET_ACTIVITIES_TEMPLATE_LIST,
          payload: response.data.data,
        });
      }
      return dataReturn ? response.data.data : true;
    })
    .catch(response => {
      console.warn(response);
      return false;
    });
}

export const setSalesCatalystPreferenceStudy = scStudy => {
  return ({
    type: types.SET_SC_STUDY,
    payload: scStudy,
  });
};

export function setSalesCatalystPreferenceData(preferenceData) {
  return ({
    type: types.SET_SALES_CATALYST_PREFERENCE_DATA,
    data: preferenceData,
  });
}

export function updateSalesCatalystSessionStudy(study, configObj) {
  const configurationObj = _.cloneDeep(configObj);
  configurationObj._sc[PREFERENCE_STUDY] = study.pn;
  return ({
    type: types.UPDATE_SALES_CATALYST_SESSION_STUDY,
    configurationObj,
  });
}

export const saveSalesCatalystSessionData = (preferenceData, sessionPref = false) => {
  return (dispatch, getState) => {
    setSalesCatalystDataOnSave(preferenceData, dispatch, getState, sessionPref);
  };
};
